<div class="min-h-[calc(100vh-68px)] bg-[#FCF9F8] py-4 px-3 sm:px-6 lg:px-8">
  <div class="max-w-[1400px] mx-auto">
    <!-- Top Executive Breadcrumb & Navigation -->
    <div class="flex flex-wrap items-center justify-between gap-3 mb-4 bg-white/80 backdrop-blur-md px-5 py-3 rounded-2xl border border-rose-100 shadow-2xs">
      <div class="flex items-center gap-3">
        <span class="px-3 py-1 rounded-full bg-rose-100 text-[#B01E3E] text-[11px] font-black uppercase tracking-wider flex items-center gap-1.5">
          <i class="bi bi-patch-check-fill text-[#B01E3E]"></i> Express VIP Suite
        </span>
        <h1 class="text-xl sm:text-2xl font-display font-bold text-gray-900 m-0 flex items-center gap-2">
          Personal Match Manager Suite
          <span class="bg-gradient-to-r from-amber-400 to-yellow-500 text-slate-950 text-[10px] font-black px-2.5 py-0.5 rounded-full uppercase tracking-wider shadow-2xs">PRO</span>
        </h1>
      </div>

      <div class="flex items-center gap-2.5">
        <a routerLink="/partner-preferences" class="px-3.5 py-2 rounded-xl bg-gray-50 hover:bg-rose-50 text-gray-700 hover:text-[#B01E3E] text-xs font-bold transition-all border border-gray-200/80 flex items-center gap-1.5 no-underline shadow-2xs">
          <i class="bi bi-sliders text-[#B01E3E]"></i> Preferences
        </a>
        <a routerLink="/dashboard" class="px-4 py-2 rounded-xl bg-[#B01E3E] hover:bg-rose-900 text-white text-xs font-bold transition-all shadow-2xs flex items-center gap-1.5 no-underline">
          <i class="bi bi-arrow-left"></i> Dashboard
        </a>
      </div>
    </div>

    <!-- The Concierge Workspace (Split-Panel Layout inside) -->
    <app-rm-concierge-chat [profileId]="profileId"></app-rm-concierge-chat>
  </div>
</div>
